var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    class: _vm.typeClass,
    attrs: {
      "visual": _vm.typeName
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm.isAuthorized ? [_c('div', {
    staticClass: "mb-10"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-select', {
    staticClass: "max-w200",
    attrs: {
      "items": _vm.statuses,
      "item-text": "text",
      "item-value": "value",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        _vm.page = 1;

        _vm.search(true);
      }
    },
    model: {
      value: _vm.filter.isDone,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "isDone", $$v);
      },
      expression: "filter.isDone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm.isRequester ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.goWrite
    }
  }, [_vm._v(_vm._s(_vm.typeName) + " 신청")]) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.goItem
    },
    scopedSlots: _vm._u([{
      key: "item.area",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(_vm._s(item.areaText))];
      }
    }, {
      key: "item.title",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('div', {
          staticClass: "ellip"
        }, [_vm._v(_vm._s(item.title))])];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('span', {
          class: _vm.getStatusClassName(item.status)
        }, [_vm._v(" " + _vm._s(item.status))])];
      }
    }, {
      key: "item.duration",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(_vm._s(item.startsAt.toDate()) + " ~ " + _vm._s(item.endsAt.toDate()))];
      }
    }], null, true)
  })], 1), _c('div', {
    staticClass: "pagination-container"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)])] : [_c('div', {
    staticClass: "card card--primary text-center"
  }, [_c('p', {
    staticClass: "text-18 text-md-16 font-weight-medium"
  }, [_vm._v("권한이 없습니다.")])])]], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }